<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingDocSubtypes">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Nome do Subtipo de documentos: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.name ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome do Subtipo de documentos"
					v-model="docSubtype.name"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="PT-BR"
					value="PT-BR"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingDocSubtypes">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="secondName"
					>Nome do Subtipo de documentos: *</label
				>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.secondName ? 'alert' : '']"
					id="secondName"
					type="text"
					placeholder="Nome do Subtipo de documentos"
					v-model="docSubtype.secondName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.secondName">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="EN-US"
					value="EN-US"
				/>
			</div>
		</div>
		<div
			class="detail-form__actions"
			:class="newDocSubtype ? 'new-docSubtype' : ''"
			v-show="!isLoadingDocSubtypes"
		>
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newDocSubtype"
			>
				Excluir Subtipo de documentos
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingDocSubtypes">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Subtipo de documentos'"
			:subtitle="'Tem certeza que deseja excluir este subtipo de documentos?'"
			:loader="isLoadingDocSubtypes"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_DOC_SUBTYPE_BY_ID,
	CREATE_DOC_SUBTYPE,
	UPDATE_DOC_SUBTYPE,
	DELETE_DOC_SUBTYPE,
} from '@/store/modules/docSubtypeManagement/actions';
import { mask } from 'vue-the-mask';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';

export default {
	name: 'DocSubtypeForm',
	directives: { mask },
	components: { GenericMultiselect, SpinnerIcon, DeleteModal },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		docSubtype: {
			name: '',
			secondName: '',
		},
		requiredFields: {
			name: false,
			secondName: false,
		},
		newDocSubtype: false,
		isEditing: false,
		showDeleteModal: false,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getDocSubtype({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedDocSubtype = res.data;

				selectedDocSubtype.forEach((item) => {
					if (item.language == 'pt-br') this.docSubtype.name = item.name;
					if (item.language == 'en-us') this.docSubtype.secondName = item.name;
				});
			});
		} else {
			this.newDocSubtype = true;
		}
	},
	methods: {
		...mapActions('docSubtypeManagement', {
			getDocSubtype: GET_DOC_SUBTYPE_BY_ID,
			createNewDocSubtype: CREATE_DOC_SUBTYPE,
			updateDocSubtype: UPDATE_DOC_SUBTYPE,
			deleteDocSubtype: DELETE_DOC_SUBTYPE,
		}),
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteDocSubtype({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/config/docSubtype' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createDocSubtype() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.docSubtype.name, language: 'pt-br' },
				{ name: this.docSubtype.secondName, language: 'en-us' },
			);

			this.createNewDocSubtype({ vm: this, body: body }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/config/docSubtype' });
				}
			});
		},
		confirmUpdate() {
			const body = { itens: [] };

			body.itens.push(
				{ name: this.docSubtype.name, language: 'pt-br' },
				{ name: this.docSubtype.secondName, language: 'en-us' },
			);

			this.updateDocSubtype({ vm: this, id: this.$route.query.id, body: body }).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateFields() {
			this.requiredFields = {
				name: true,
				secondName: true,
			};

			if (this.docSubtype.name) this.requiredFields.name = false;
			if (this.docSubtype.secondName) this.requiredFields.secondName = false;

			if (!this.docSubtype.name || !this.docSubtype.secondName) {
				return;
			}

			if (!this.newDocSubtype) {
				this.confirmUpdate();
			} else {
				this.createDocSubtype();
			}
		},
	},
	computed: {
		...mapGetters('docSubtypeManagement', ['isLoadingDocSubtypes']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'DocSubtypeForm.scss';
</style>
